import React from 'react';
import './SurveyComplete.scss';

class SurveyComplete extends React.Component {
  checkDateExpire = (datetime) => {
    if (!datetime) return 0;
    const date = new Date(datetime);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  render() {
    const locakStorage = localStorage.getItem('is_done');
    const params = JSON.parse(locakStorage);
    const datetime = params ? params.datetime : '';
    const is_done = params ? params.status : false;
    const dateExpire = this.checkDateExpire(datetime);

    if (dateExpire > 3 && is_done === true) {
      localStorage.removeItem('is_done');
      window.location.reload();
    }

    return (
      <div className="SurveyComplete">
        <div className="logo">
          <img
            src="https://fbtsdev.blob.core.windows.net/survey/Thaipost/logo-thaipost.png"
            alt="thaipost"
          />
        </div>
        <div>ขออภัยค่ะ</div>

        <div>ท่านได้ทำการตอบแบบสอบถามแล้ว</div>

        <div>
          ขอขอบคุณสำหรับความคิดเห็นของท่านที่จะช่วยให้ไปรษณีย์ไทยนำไปพัฒนาบริการให้ดียิ่งขึ้นต่อไป
        </div>

        <div className="last-description">
          <div>
            หากมีข้อสงสัยสามารถติดต่อศูนย์บริการลูกค้า
            <span>ไปรษณีย์ได้ที่ 1545</span>
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyComplete;
